import React from "react";

/**
 * Tappable settings hub row for extension drill-down navigation.
 *
 * @example
 * <ActionItemsSettingsHubRow
 *   title="Gmail drafts"
 *   summary="Not connected"
 *   summaryTone="warning"
 *   onClick={() => setScreen("gmail-drafts")}
 * />
 */
const ActionItemsSettingsHubRow = ({
  title,
  summary,
  summaryTone = "",
  onClick,
}) => (
  <button
    type="button"
    className="settings-hub-row"
    onClick={onClick}
  >
    <span className="settings-hub-row__text">
      <span className="settings-hub-row__title">{title}</span>
      <span
        className={`settings-hub-row__summary${
          summaryTone ? ` settings-hub-row__summary--${summaryTone}` : ""
        }`}
      >
        {summary}
      </span>
    </span>
    <span className="settings-hub-row__chevron" aria-hidden="true">
      ›
    </span>
  </button>
);

export default ActionItemsSettingsHubRow;
